// extracted by mini-css-extract-plugin
export default {"counter":"Counter_counter__HQ-9a","active":"Counter_active__VCYy1"};